import { useEffect } from 'react'

import { PageName } from '@/enums/pageName'

import { IUser } from '@/auth/types'
import { useSession } from '@/core/session/useSession'
import { trackPageView } from '@/events/events'

interface UsePageLoadTrackingProps {
  pageName: PageName
  config: IConfig
  user: IUser | null
  title: string
}

export const usePageLoadTracking = ({
  pageName,
  config,
  user,
  title,
}: UsePageLoadTrackingProps) => {
  const sessionContext = useSession()
  useEffect(
    () => {
      trackPageView(
        pageName,
        config.PARTNER_ID,
        config.APP_ID,
        config.PAGE_SET_ID,
        sessionContext,
        user
      )
      document.title = title
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
}
